var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.$store.state.profile.expiredAt &&
    new Date(_vm.$store.state.profile.expiredAt) < Date.now()
  )?_c('b-alert',{attrs:{"variant":"danger","dismissible":"","fade":"","show":!_vm.isHide},on:{"dismissed":function($event){_vm.isHide = true}}},[_c('div',{staticClass:"alert-body text-center"},[_vm._v(" "+_vm._s(_vm.$t("alert.yourAccountIsExpired"))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }